import { render, staticRenderFns } from "./LetterTemplates.vue?vue&type=template&id=424380fd&scoped=true"
import script from "./LetterTemplates.vue?vue&type=script&lang=js"
export * from "./LetterTemplates.vue?vue&type=script&lang=js"
import style0 from "./LetterTemplates.vue?vue&type=style&index=0&id=424380fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424380fd",
  null
  
)

export default component.exports